import React from "react";
import Answers from "./Answers.jsx";

function QuestionsMenu() {
  return <Answers />;
}

export default QuestionsMenu;
